import { SingleTableBoxScene } from "@/shared/components/ui";
import { Tab, Tabs } from "@mui/material";
import { a11yProps, texto, useCheckPermissions } from "@/shared";
import { useState } from "react";
import { CustomTabPanel } from "../..";
import SupervicionVentaSolicitudPage from "./solicitud-ingreso-prospecto-solicitud/SolicitudIngresoProspectoSolicitudPage";
import { PermissionsEnum } from "@/auth/interfaces";
import { SolicitudTutorDescuentoEstadoSolicitudEnum } from "@/shared/interfaces";

const SolicitudIngresoProspectoPage = () => {

  useCheckPermissions(PermissionsEnum.api_view_solicitudingresobeneficio);
  const [valueTab, setValueTab] = useState(0);

  return (
    <SingleTableBoxScene title="Solicitud Ingreso Beneficio">

      <Tabs
        value={valueTab}
        onChange={(_event: React.SyntheticEvent, newValue: number) => {
          setValueTab(newValue);
        }}
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
        aria-label="scrollable force tabs preventa"
      >
        <Tab label={texto.solicitud} {...a11yProps(0)} />
        <Tab label={texto.aprobado} {...a11yProps(1)} />
        <Tab label={texto.rechazadas} {...a11yProps(2)} />
      </Tabs>

      <CustomTabPanel index={valueTab} value={0}>
        <SupervicionVentaSolicitudPage
          enableAction={true}
          estadoSolicitud={SolicitudTutorDescuentoEstadoSolicitudEnum.EN_ESPERA}
        />
      </CustomTabPanel>
      <CustomTabPanel index={valueTab} value={1}>
        <SupervicionVentaSolicitudPage
          enableAction={false}
          estadoSolicitud={SolicitudTutorDescuentoEstadoSolicitudEnum.APROBADO}
        />
      </CustomTabPanel>
      <CustomTabPanel index={valueTab} value={2}>
        <SupervicionVentaSolicitudPage
          enableAction={false}
          estadoSolicitud={SolicitudTutorDescuentoEstadoSolicitudEnum.RECHAZADO}
        />
      </CustomTabPanel>


    </SingleTableBoxScene>

  );
}

export default SolicitudIngresoProspectoPage